import React, { useState, useEffect, useContext } from 'react';
import { Link } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { createMuiTheme, Slide, Container, Dialog, Toolbar, Typography, Fab, CssBaseline, Backdrop, CircularProgress, Grid, AppBar } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { ThemeProvider } from '@material-ui/styles';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import '../../../css/react-bootstrap-table2.css';
import styles from "../../../jss/material-dashboard-react/views/dashboardStyle.js";
import { GlobalTheme } from '../../../layouts/theme';
import { Theme } from '../../contexts/themeContext';
import { Context } from "../../contexts/siteContext";
import { HttpService } from "../../../apiAuthorization/httpService";
import Card from "../../card/card.js";
import CardBody from "../../card/cardBody.js";
import AddRoundList from "../roundList/roundListAdd";
import RoundListLocation from "../roundList/roundListLocation";
import AlertDialog from '../../common/alertDialog';
import ConfirmDialog from '../../common/confirmDialog';
import SmallMenu from '../../header/smallMenu';
import StatusIcon from '../../common/statusIcon';

const useStyles = makeStyles(styles);
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function RoundList(props) {
    const classes = useStyles();
    const { defaultSite } = useContext(Context);
    const { theme } = useContext(Theme);
    const [roundListOpen, setRoundListOpen] = useState(false);
    const [locationOpen, setLocationOpen] = useState(false);
    const [displayOrderChanged, setDisplayOrderChanged] = useState(false);
    const [alertOpen, setAlertOpen] = React.useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [severity, setSeverity] = React.useState('');
    const [errorMessage, setErrorMessage] = React.useState('');
    const [roundListId, setRoundListId] = useState();
    const [roundList, setRoundList] = useState([]);
    const [recordToBeEdit, setRecordToBeEdit] = useState([]);
    const [recordToLocation, setRecordToLocation] = useState([]);
    const [backDrop, setBackDrop] = useState(false);
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);

    const rowStyle = (rowIndex) => {
        return { color: currentTheme.text, background: rowIndex % 2 === 0 ? '' : currentTheme.alternateGridRow };
    };

    const alertClose = () => {
        setAlertOpen(false);
    };

    const confirmClose = () => {
        setConfirmOpen(false);
    };

    const locationClose = () => {
        setLocationOpen(false);
    };

    const roundListClose = () => {
        setRoundListOpen(false);
    };

    const listRoundListLocations = (item) => {
        setLocationOpen(true);
        setRecordToLocation(item);
    };

    const addRoundList = () => {
        setRoundListOpen(true);
        setRecordToBeEdit([]);
    };

    const editRoundList = (item) => {
        setRoundListOpen(true);
        setRecordToBeEdit(item);
    };

    const updateList = (item) => {
        const data = roundList;
        const index = data.findIndex(data => data.RoundListId === item.RoundListId);
        if (index === -1)
            data.push(item);
        else
            data[index].RoundListName = item.RoundListName;
        setRoundList(data);
    };

    const deleteRoundListConfirm = (id) => {
        setConfirmOpen(true);
        setRoundListId(id);
    };

    const deleteRoundList = () => {
        setConfirmOpen(false);
        HttpService.post('/RoundList/DeleteRoundList', { RoundListId: roundListId })
        .then((result) => {
            if (result.error) {
                setErrorMessage(result.message);
                setSeverity('error');
                setAlertOpen(true);
            }
            else {
                const data = roundList.filter(roundList => roundList.RoundListId !== roundListId);
                setRoundList(data);
            }
        },
        (error) => {
            console.log(error);
        });
    };

    const getRoundLists = () => {
        setBackDrop(true);
        HttpService.post('/RoundList/GetRoundLists', { SiteCode: defaultSite.id })
        .then((result) => {
            setRoundList(result.data);
            setBackDrop(false);
        },
        (error) => {
            console.log(error);
        });
    };

    const saveRoundListDisplayOrder = () => {
        if (roundList.length > 0 && displayOrderChanged) {
            let displayOrders = [];
            for (let index = 0; index < roundList.length; index++) {
                displayOrders.push(roundList[index].RoundListId);
            }

            HttpService.post('/RoundList/SaveRoundListDisplayOrder', {
                RoundListName: JSON.stringify(displayOrders),
                siteCode: defaultSite.id
            })
            .then((result) => {
            },
            (error) => {
                console.log(error);
            });
        }
    };

    const handleDragEnd = (results) => {
        let tempdata = [...roundList];
        if (results.destination !== null) {
            let [selectedRow] = tempdata.splice(results.source.index, 1);
            tempdata.splice(results.destination.index, 0, selectedRow);
            setRoundList(tempdata);
            setDisplayOrderChanged(true);
        }
    };

    useEffect(() => {
        getRoundLists();
        // eslint-disable-next-line
    }, []);

    const fetchData = () => {
        return (
            <React.Fragment>
                <ThemeProvider theme={currentTheme}>
                    <CssBaseline />
                    <Backdrop className={classes.backdrop} id="roundListBackdrop" open={backDrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <Dialog zindex="100" fullScreen open={roundListOpen} onClose={roundListClose} TransitionComponent={Transition}>
                        <AddRoundList parentCallback={roundListClose}
                            refreshGrid={updateList}
                            model={recordToBeEdit}
                        />
                    </Dialog>
                    <Dialog zindex="100" fullScreen open={locationOpen} onClose={locationClose} TransitionComponent={Transition}>
                        <RoundListLocation parentCallback={locationClose}
                            model={recordToLocation}
                        />
                    </Dialog>
                    <Container maxWidth="xl" style={{ height: '95%' }} className={props.styles}>
                        <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                            <Toolbar>
                                <Link onClick={() => { saveRoundListDisplayOrder(); }} to="/"><KeyboardBackspaceIcon /></Link>
                                <Grid container direction="row" alignItems="center">
                                    <Grid item>
                                        <Typography variant="h6" className={classes.title}>&nbsp;Round List</Typography>
                                    </Grid>
                                    <Grid item>
                                        <StatusIcon />
                                    </Grid>
                                </Grid>
                                <Grid container justify="flex-end">
                                    <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="add" onClick={addRoundList}>
                                        <AddIcon />
                                    </Fab>
                                    <SmallMenu modified={false} />
                                </Grid>
                            </Toolbar>
                        </AppBar>
                        <Card color="primary" style={{ height: '100%', background: currentTheme.background }}>
                            <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                                <div className="react-bootstrap-table">
                                    <DragDropContext onDragEnd={(results) => handleDragEnd(results)}>
                                        <table className="table table-hover table-bordered">
                                            <thead>
                                                <tr>
                                                    <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground, width: "50px" }}>#</th>
                                                    <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground, }}>Round List Name</th>
                                                    <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground, }}>Site Name</th>
                                                    <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground, }}></th>
                                                </tr>
                                            </thead>
                                            <Droppable droppableId="tbody">
                                                {(provided) => (
                                                    <tbody ref={provided.innerRef} {...provided.droppableProps} className="text-capitalize">
                                                        {roundList?.map((item, index) => (
                                                            <Draggable draggableId={item.RoundListId.toString()} index={index} key={item.RoundListId.toString()}>
                                                                {
                                                                    (provided, snapshot) => (
                                                                        <tr ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                                            <td style={rowStyle(index)}>{index + 1}</td>
                                                                            <td style={rowStyle(index)}>{item.RoundListName}</td>
                                                                            <td style={rowStyle(index)}>{item.SiteName}</td>
                                                                            <td style={rowStyle(index)}>
                                                                                <LocationOnIcon style={{ color: currentTheme.secondary, cursor: 'pointer', float: 'right' }} onClick={() => { listRoundListLocations(item); }} />
                                                                                <DeleteIcon style={{ color: currentTheme.secondary, cursor: 'pointer', float: 'right' }} onClick={() => deleteRoundListConfirm(item.RoundListId)} />
                                                                                <EditIcon style={{ color: currentTheme.secondary, cursor: 'pointer', float: 'right' }} onClick={() => { editRoundList(item); }} />
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                }
                                                            </Draggable>
                                                        ))}
                                                        {provided.placeholder}
                                                    </tbody>
                                                )}
                                            </Droppable>
                                        </table>
                                    </DragDropContext>
                                </div>
                                <ConfirmDialog open={confirmOpen} close={confirmClose} onConfirm={deleteRoundList}
                                    title="Delete Round List" message="Are you sure you want to delete the selected Round List?" />
                                <AlertDialog open={alertOpen} close={alertClose} message={errorMessage} severity={severity} />
                            </CardBody>
                        </Card>
                    </Container>
                </ThemeProvider>
            </React.Fragment>
        );
    }

    let content = fetchData();
    return (
        <>
            {content}
        </>
    );
}
